import styled from 'styled-components';
import { getScrollBarStyles } from '../../../../config/styles';
import { optionHover } from '../../../../styles/shareableStyles';
import { theme } from '../../../../styles/theme';

export const ListContainer = styled.div`
  height: 220px;
  overflow-y: auto;
  align-items: center;
  display: flex;
  flex-direction: column;
  ${getScrollBarStyles(4)}
`;

export const ListItem = styled.div<{ $isActive: boolean }>`
  padding: 5px 16px;
  color: ${theme.colors.secondary800};
  font-weight: 500;
  line-height: 1.5;
  cursor: pointer;
  width: 100%;
  text-align: left;
  &:hover {
    ${optionHover};
  }
  ${({ $isActive }) => $isActive && optionHover};
`;
